import { SelectItem } from '@sofology/sofologycomponents';

export const APPLICATION_NAME = 'web';
export const NOT_ALLOW_DOUBLE_SPACES_REGEX = / {1,}/g;
export const NOT_ALLOW_ANY_SPACES_REGEX = /\s+/gi;
export const NUMBER_VALID_MASK = /^\d+$/;

export const selectItemsMonths: SelectItem[] = [
    { title: '0', value: '0' },
    { title: '1', value: '1' },
    { title: '2', value: '2' },
    { title: '3', value: '3' },
    { title: '4', value: '4' },
    { title: '5', value: '5' },
    { title: '6', value: '6' },
    { title: '7', value: '7' },
    { title: '8', value: '8' },
    { title: '9', value: '9' },
    { title: '10', value: '10' },
    { title: '11', value: '11' },
];

export const selectItemsYears: SelectItem[] = [
    { title: '0', value: '0' },
    { title: '1', value: '1' },
    { title: '2', value: '2' },
    { title: '3', value: '3' },
    { title: '4', value: '4' },
    { title: '5', value: '5' },
    { title: '6+', value: '6' },
];